import Styles from "../editScreenStyles.module.css";

function DateTimeEdit({
  utilities,
  fields,
  updateClicked,
  cancelClicked
}) {

  const {
    createCustomLabelInput
  } = utilities;

  return (
    <div>
      <div className={Styles.title}>Date Of Incident</div>
      <div className={Styles.column}>
        <div className={Styles.row}>
          {createCustomLabelInput(
            fields.whereDate,
            "50%",
            Styles.input,
            Styles.label,
            {type: "date"}
          )}
         {createCustomLabelInput(
            fields.whereTime,
            "50%",
            Styles.input,
            Styles.label,
            {type: "time"}
          )}
        </div>
        <div className={Styles.buttons}>
          <button
            type="button"
            className={Styles.button}
            onClick={cancelClicked}
          >
            Cancel
          </button>
          <button
            type="button"
            className={Styles.button}
            onClick={updateClicked}
          >
            Update
          </button>
        </div>
      </div>
    </div>
  );
}

export default DateTimeEdit;
